import React from 'react';
import {loadable as _loadable} from './index';
/**
 * This *must* export a `loadable` function to ensure compatibility with the `@loadable/babel-plugin`.
 * @see https://www.smooth-code.com/open-source/loadable-components/docs/babel-plugin/#loadable-detection
 */
export function loadable(loadableComponent, options) {
  const Component = _loadable(loadableComponent, options);
  /**
   * In the case of react-router@3 we have to account for it not utilizing `forwardRef`.
   * @see https://github.com/smooth-code/loadable-components/issues/374#issuecomment-507942117
   */
  return (props) => <Component {...props} />;
}
